import React, { useState } from "react";
import { NavLink } from 'react-router-dom';
import "./Header.css";
import logo from "../assets/images/qodes_logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <nav className="nav">
        <img
          src={logo}
          alt="Qodes logo"
          className="logo"
          onClick={() => window.location.href = '/'}
        />

        {/* Hamburger menu button */}
        <button
          className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Menu */}
        <ul className={`menu ${isMenuOpen ? 'menu-open' : ''}`}>
          <li><NavLink to="/" onClick={closeMenu}>Home</NavLink></li>
          <li><NavLink to="/about" onClick={closeMenu}>About</NavLink></li>
          <li><NavLink to="/news" onClick={closeMenu}>News</NavLink></li>
          <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>
        </ul>

        {/* Mobile menu overlay */}
        {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
      </nav>
    </header>
  );
};

export default Header;
